import { set_dimensions } from "../../../services/global.services";

var email_styles = function (app_dimensions: any) {
  return {
    header: {
      display: "flex" as const,
      width: set_dimensions().desktop ? "100%" : "",
      padding: set_dimensions().desktop
        ? "25px 88px 10px 88px"
        : "15px 16px 0px 16px",
      flexDirection: "column" as const,
      alignItems: "center",
      justifyContent: "center",
      gap: set_dimensions().mobile ? "8px" : "",
      alignSelf: set_dimensions().mobile ? "stretch" : "",
    },
    title: {
      alignSelf: "stretch" as const,
      color: "var(--Black---1000, #191924)",
      textAlign: "center" as const,
      fontFamily: "Montserrat",
      fontSize: set_dimensions().desktop ? "24px" : "18px",
      fontStyle: "normal",
      fontWeight: set_dimensions().desktop ? 700 : 600,
      lineHeight: set_dimensions().desktop ? "32px" : "24px",
      margin: "0",
      padding: "0",
    },
    subtitle: {
      width: set_dimensions().desktop ? "468px" : "",
      color: "var(--Gray---800, #4F5467)",
      textAlign: "center" as const,
      fontFamily: "Montserrat",
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "20px",
      margin: "0",
      padding: "0",
    },
  };
};

export default email_styles;